import * as $ from "jquery";
import _ from "underscore";
import imkt from '../../imkt';
import url from '../../utils/url';

// DOM Ready
$(function () {
  const NAV_HEIGHT = $(".imkt-sticky-wrapper").outerHeight() || 0;

  if (!imkt.isEditMode) {
    // Scroll down to job openings when top button is clicked
    $(".js-scrollToJobs").click(function () {
      $("html, body").animate(
        {
          scrollTop: (($("#jobListSection").offset()) as { top: number }).top - NAV_HEIGHT,
        },
        500
      );
      return false;
    });
  }
});

// Lever API functions
$(function () {
  if (!imkt.isEditMode) {
    imkt.utils = imkt.utils || {};

    const JOB_KEYS = {
      BUSINESS: "Business",
      DATA_AND_ANALYTICS: "Data & Analytics",
      DESIGN: "Design",
      ENGINEERING: "Engineering",
      MARKETING_AND_SALES: "Marketing & Sales",
      PRODUCT_MANAGEMENT: "Product Management",
      SUPPORT: "Support",
      TRELLO: "Trello",
      CAMPUS: "Campus",
      INTERN: "Intern",
      STUDENTS: "Students",
      OTHER: "Other",
    };

    imkt.utils.Lever = {
      apiCompanyIdentifier: "Atlassian",

      teamFilterGroups: {
        [JOB_KEYS.BUSINESS]: [JOB_KEYS.BUSINESS],
        [JOB_KEYS.DATA_AND_ANALYTICS]: [JOB_KEYS.DATA_AND_ANALYTICS],
        [JOB_KEYS.DESIGN]: [JOB_KEYS.DESIGN],
        [JOB_KEYS.ENGINEERING]: [JOB_KEYS.ENGINEERING],
        [JOB_KEYS.MARKETING_AND_SALES]: [JOB_KEYS.MARKETING_AND_SALES],
        [JOB_KEYS.PRODUCT_MANAGEMENT]: [JOB_KEYS.PRODUCT_MANAGEMENT],
        [JOB_KEYS.SUPPORT]: [JOB_KEYS.SUPPORT],
        [JOB_KEYS.TRELLO]: [JOB_KEYS.TRELLO],
        [JOB_KEYS.CAMPUS]: [JOB_KEYS.CAMPUS],
        [JOB_KEYS.INTERN]: [JOB_KEYS.INTERN],
        [JOB_KEYS.STUDENTS]: [JOB_KEYS.CAMPUS, JOB_KEYS.INTERN],
        [JOB_KEYS.OTHER]: [JOB_KEYS.OTHER],
      },

      getHostedUrl: function (job: { urls: { hostedUrl: any; }; }) {
        return job.urls.hostedUrl;
      },

      request: function (endpoint: string, data: object, callbacks: { [name: string]: any }) {
        var self = this,
          originalArgs = arguments;

        callbacks = callbacks || {};

        return $.ajax({
          dataType: "json",
          url: [imkt.constants.rootPath, ".rest/", endpoint].join(""),
          data: data,
          timeout: 10000,
          beforeSend: callbacks.beforeSend,
          success: callbacks.success,
          error: function () {
            if (typeof callbacks.error === "function") {
              callbacks.error();
            }
            setTimeout(function () {
              self.request.apply(self, originalArgs);
            }, 1000);
          },
          complete: callbacks.complete,
        });
      },

      postingsRequest: function (queryParams: Object, cb: Function) {
        return this.request(
          "postings",
          {
            // default params
            limit: 10,
            offset: 0,
            country: "",
            region: "",
            city: "",
            department: "",
            q: "",
            ...queryParams,
          },
          { success: cb }
        );
      },

      getAllPropertyGroups: function (allJobsData, groupName, identifyingKey) {
        return _.uniq(
          _.compact(_.pluck(allJobsData, groupName)),
          function (group) {
            if (identifyingKey) {
              return group[identifyingKey];
            } else {
              return group;
            }
          }
        );
      },
    };
    // END imkt.utils.Lever

    imkt.careers = imkt.careers || {};

    /*
     * BEGIN JOBS LIST
     */

    imkt.careers.JobsList = function (domRoot, params) {
      this.$domRoot = $(domRoot);
      this.params = $.extend(
        true,
        {},
        {
          // define default params here
          filterType: "all",
          filterValue: "all",
          groupByTeam: true,
          // cacheExpiration: 1000 * 60 * 60,
          cacheExpiration: 0,
          queryParams: {
            limit: 100,
            q: "",
          },
        },
        params
      );

      this.init();
    };

    imkt.careers.JobsList.prototype = {
      activeFilters: {},

      init: function () {
        var self = this;

        // var cachedData = this.fetchDataFromStorage();
        var underscoreRequest = $.Deferred();

        if (typeof _ === "undefined") {
          underscoreRequest = $.getScript(
            imkt.constants.libPath +
            "underscore.js" +
            imkt.constants.cdnVersionQuery
          );
        } else {
          // underscore already exists
          underscoreRequest.resolve();
        }

        // this is called once we have our processed data, either from cache or API
        var hasProcessedData = function (processedJobs: any) {
          self.allJobsData = processedJobs;
          // if(!cachedData || forcePersist){
          //     self.persistDataToStorage(self.allJobsData);
          // }

          $.when(underscoreRequest).then(function () {
            // processed all jobs data including adding missing customField data
            if (!self.teamFilterGroups) {
              self.teamFilterGroups = _.clone(
                imkt.utils.Lever.teamFilterGroups
              );
            }

            // the for anything that is not a team filter,
            // remove 'Campus' and 'Intern' groups and consolidate them into 'Students'
            if (self.params.filterType !== "team") {
              self.teamFilterGroups.Students = [].concat(
                self.teamFilterGroups.Campus,
                self.teamFilterGroups.Intern
              );
              delete self.teamFilterGroups.Campus;
              delete self.teamFilterGroups.Intern;
            }

            // filter out all irrelevant results on the frontend
            if (self.params.filterType === "location") {
              self.allJobsData = self.allJobsData.filter(
                (job) => job.location === self.params.filterValue
              );
            } else if (self.params.filterType === "team") {
              self.allJobsData = self.allJobsData.filter((job) =>
                _.contains(job.team, self.params.filterValue)
              );
            }

            // underscore is available
            self.precompileTemplates();

            // group jobs
            self.allJobsDataGrouped = self.params.groupByTeam
              ? self.getJobsGroupedByTeam()
              : self.getFlattenedJobGroup();

            // build initial DOM
            self.$domRoot.empty();
            self.buildContainers();

            // initialize and render
            self.initializeState();
            self.buildFilters();
            self.updateUI();
          });
        };

        // if cache exists
        // if(cachedData){
        //     hasProcessedData(cachedData);
        // } else {
        imkt.utils.Lever.postingsRequest(
          this.params.queryParams,
          function (resultData: { postings: any; }) {
            $.when(underscoreRequest).then(function () {
              self.preprocessData(resultData.postings, hasProcessedData);
            });
          }
        );
        // }
      },

      preprocessData: function (allJobsData: any[], cb: Function) {
        //filter to include only those with all required properties
        allJobsData = _.filter(allJobsData, function (job) {
          return (
            job.text &&
            job.categories &&
            typeof job.categories.location === "string" &&
            job.categories.location !== "_Job Posting Templates"
          );
        });

        // clean up location string and sort by it
        allJobsData = _.sortBy(allJobsData, function (job) {
          job.location = job.categories.location.split(",")[0];

          // rename all remote locations
          if (job.location.toUpperCase().indexOf("HOME OFFICE") > -1) {
            job.location = "Remote";
          }

          return job.location;
        });

        // categorise teams
        _.each(allJobsData, function (job) {
          job._hostedUrl = imkt.utils.Lever.getHostedUrl(job);
          var _team,
            teamGroups: string[] = [],
            requisition = job.requisition,
            postingTitle = job.text;

          if (requisition !== null && requisition.customFields) {
            if (
              requisition.customFields.product &&
              requisition.customFields.product
                .toUpperCase()
                .includes(JOB_KEYS.TRELLO.toUpperCase())
            ) {
              teamGroups.push(JOB_KEYS.TRELLO);
            }

            if (
              requisition.customFields.subgroup &&
              requisition.customFields.subgroup.toUpperCase().includes("CSS")
            ) {
              teamGroups.push(JOB_KEYS.SUPPORT);
            }

            if (requisition.customFields.costcenter) {
              _team = requisition.customFields.costcenter.toUpperCase();

              // main groups
              if (_team.includes("G&A")) {
                teamGroups.push(JOB_KEYS.BUSINESS);
              } else if (_team.includes("MKTG")) {
                teamGroups.push(JOB_KEYS.MARKETING_AND_SALES);
              } else if (_team.includes("R&D:PRODUCT")) {
                teamGroups.push(JOB_KEYS.PRODUCT_MANAGEMENT);
              } else if (_team.includes("R&D:DESIGN")) {
                teamGroups.push(JOB_KEYS.DESIGN);
              } else if (_team.includes("R&D")) {
                teamGroups.push(JOB_KEYS.ENGINEERING);
              }
            }

            // map of job family fragment to associated team
            const teamByJobFamily = {
              Admin: JOB_KEYS.BUSINESS,
              Data: JOB_KEYS.DATA_AND_ANALYTICS,
              [JOB_KEYS.DESIGN]: JOB_KEYS.DESIGN,
              Finance: JOB_KEYS.BUSINESS,
              GTM: JOB_KEYS.MARKETING_AND_SALES,
              IT: JOB_KEYS.BUSINESS,
              Legal: JOB_KEYS.BUSINESS,
              People: JOB_KEYS.BUSINESS,
              Product: JOB_KEYS.PRODUCT_MANAGEMENT,
              "R&D": JOB_KEYS.ENGINEERING,
              Sales: JOB_KEYS.MARKETING_AND_SALES,
              [JOB_KEYS.SUPPORT]: JOB_KEYS.SUPPORT,
            };

            // get job family group from requisition and make it camel case
            const { jobfamilygroup: jobFamilyGroup } = requisition.customFields;

            if (jobFamilyGroup) {
              // find any additional teams that this job should be categorized under
              // based on its associated job family group
              const additionalTeamsFromJobFamilies = Object.keys(
                teamByJobFamily
              )
                .filter(
                  (jobFamilyKey) =>
                    jobFamilyGroup.includes(jobFamilyKey) &&
                    !teamGroups.includes(teamByJobFamily[jobFamilyKey])
                )
                .map((jobFamilyKey) => teamByJobFamily[jobFamilyKey]);

              teamGroups.push(...additionalTeamsFromJobFamilies);
            }

            // leaving this here as a way to log how many additional team categorizations have
            // been made with this logic since there appear to be many jobs still in the 'other'
            // team and therefore this will likely be added to
            // if (additionalTeamsFromJobFamilies.length)
            //     console.log(
            //         `Job id ${requisition.id}`,
            //         `- "${job.text}"`,
            //         `with job family group "${jobFamilyGroup}"`,
            //         `in ${job.categories.location}\n`,
            //         `\tAdded to team(s): ${additionalTeamsFromJobFamilies}\n\n`
            //     );
          }

          if (
            ["GRAD", "UNIVERSITY"].some(
              (substring) =>
                postingTitle.toUpperCase().includes(substring) ||
                (requisition &&
                  requisition.name.toUpperCase().includes(substring))
            )
          ) {
            teamGroups.push(JOB_KEYS.CAMPUS);
          }

          if (
            _.contains(
              postingTitle.toUpperCase().split(" "),
              JOB_KEYS.INTERN.toUpperCase()
            ) ||
            (requisition &&
              _.contains(
                requisition.name.toUpperCase().split(" "),
                JOB_KEYS.INTERN.toUpperCase()
              ))
          ) {
            teamGroups.push(JOB_KEYS.INTERN);
          }

          if (teamGroups.length === 0) {
            teamGroups.push(JOB_KEYS.OTHER);
          }

          job.team = teamGroups;
        });

        allJobsData = _.filter(
          allJobsData,
          function (posting) {
            return posting.team.length > 0;
          },
          this
        );

        // execute callback
        cb(allJobsData);
      },

      getStorageKeyName: function () {
        // disabled for now
        return [
          "ATLASSIAN_CAREERS_DATA_",
          this.params.filterType,
          "_",
          this.params.filterValue,
        ].join("");
      },

      // attempt to fetch from storage
      // if timestamp is too old, then we return null, forcing a fetch from the API
      fetchDataFromStorage: function (key: string) {
        // disabled for now
        var r = null,
          now = new Date(),
          storageValue;

        key = key || this.getStorageKeyName();

        if (imkt.core.supports.localStorage()) {
          storageValue = JSON.parse(window.localStorage.getItem(key) as string);

          if (storageValue) {
            // if expired, return null
            if (
              !storageValue.timeStamp ||
              (storageValue.timeStamp &&
                now.getTime() - storageValue.timeStamp >
                this.params.cacheExpiration)
            ) {
              r = null;
            } else {
              r = storageValue.data;
            }
          }
        }

        return r;
      },

      // store processed data to localStorage
      persistDataToStorage: function (data: any, key: string) {
        // disabled for now
        var now = new Date();

        key = key || this.getStorageKeyName();

        if (imkt.core.supports.localStorage()) {
          window.localStorage.setItem(
            key,
            JSON.stringify({
              data: data,
              timeStamp: now.getTime(),
            })
          );
        }
      },

      // build filters menu and bind change listeners
      buildFilters: function () {
        this.teamGroups = Object.keys(this.allJobsDataGrouped);
        this.locationGroups = imkt.utils.Lever.getAllPropertyGroups(
          this.allJobsData,
          "location"
        );

        // only allow team groups from our whitelist
        this.teamGroups = _.filter(
          this.teamGroups,
           (group) => {
            return this.teamFilterGroups.hasOwnProperty(group);
          },
          this
        );

        // even though 'None' is a valid group and our defined fallback
        // recruiters want it to never show up, even if a job is categorized under it...
        // so we remove it for now
        if (this.allJobsDataGrouped.hasOwnProperty("None")) {
          delete this.allJobsDataGrouped.None;
        }

        this.allJobsDataGrouped = _.pick(
          this.allJobsDataGrouped,
           (jobs: any, group: any) => {
            return this.teamFilterGroups.hasOwnProperty(group);
          },
          this
        );

        // render
        this.$filtersContainer.html(
          this.templates.filters({
            teamGroups: _.sortBy(this.teamGroups, function (group) {
              return group === "None" ? Math.Infinity : group;
            }),
            locationGroups: _.sortBy(this.locationGroups, function (group) {
              return group;
            }),
          })
        );

        // save out DOM var
        this.$filterItems = $(".filter-item", this.$filtersContainer);

        // change listener
        this.$filterItems.on(
          "change",
          function (e) {
            var $target = $(e.currentTarget),
              filterType = $target.attr("data-filter-type"),
              filter = {};

            filter[filterType] = $target.val();

            if ($target.is(":checked")) {
              this.action_applyFilter(filter);
            } else {
              this.action_applyFilter(filter, true);
            }
          }.bind(this)
        );
      },

      buildContainers: function () {
        this.$jobGroupsContainer = $('<div class="all-job-groups"></div>');
        this.$jobGroupsContainer.appendTo(this.$domRoot);
        this.bindJobTableEvents();

        this.$filtersContainer = $(
          '<form action="#" class="filters-form"></form>'
        );
        this.$filtersContainer.prependTo(this.$domRoot);
      },

      // ADD OR REMOVE FILTER HASH FROM activeFilters
      action_applyFilter: function (filter, remove) {
        if (_) {
          _.each(
            _.keys(filter),
            function (key) {
              if (!this.activeFilters[key]) {
                this.activeFilters[key] = [];
              }
              // make it an array
              if (typeof filter[key] === "string") {
                filter[key] = filter[key].split(",");
              }
              if (Array.isArray(filter[key])) {
                // toggle value from activeFilter array
                if (remove) {
                  this.activeFilters[key] = _.difference(
                    this.activeFilters[key],
                    filter[key]
                  );
                } else {
                  this.activeFilters[key] = _.union(
                    this.activeFilters[key],
                    filter[key]
                  );
                }
              }
            },
            this
          );

          this.activeFilters = _.mapObject(
            this.activeFilters,
            function (value, key) {
              // only allow valid team names in activeFilters
              if (key === "team") {
                value = _.filter(
                  value,
                  function (v) {
                    return _.contains(
                      _.map(
                        this.teamGroups,
                        function (teamGroup) {
                          return teamGroup;
                        },
                        this
                      ),
                      v
                    );
                  },
                  this
                );
              }

              return Array.isArray(value) ? _.compact(value) : value;
            },
            this
          );

          // if we have an activeFilter that points to an empty array, kill it
          _.each(
            _.keys(this.activeFilters),
            function (key) {
              if (this.activeFilters[key] && !this.activeFilters[key].length) {
                this.activeFilters[key] = null;
              }
            },
            this
          );

          this.updateURL();
          this.updateUI();
        }
      },

      initializeState: function () {
        // pull any valid params from URL into activeFilters
        this.activeFilters = _.pick(
          url.getUrlParams(),
          "team",
          "location"
        );
        _.each(
          _.keys(this.activeFilters),
          function (key) {
            if (typeof this.activeFilters[key] === "string") {
              // teams have an ampersand which ends up HTML entity encoded to '&amp;'
              // so convert back to actual ampersand character in checking for filters present
              this.activeFilters[key] = this.activeFilters[key]
                .replace("&amp;", "&")
                .split(",");
            }
          },
          this
        );
        if (!_.isEmpty(this.activeFilters)) {
          $("html, body").animate(
            {
              scrollTop:
                this.$domRoot.offset().top -
                $(".imkt-sticky.subnavigation").height(),
            },
            1
          ); // has to be > 0 for chrome to work
        }
      },

      updateUI: function () {
        // update filters menu
        if (this.$filterItems) {
          this.$filterItems.closest("li").removeClass("selected");

          _.each(
            _.keys(this.activeFilters),
            function (key) {
              _.each(
                this.activeFilters[key],
                function (value) {
                  this.$filterItems
                    .filter(
                      '[data-filter-type="' + key + '"][value="' + value + '"]'
                    )
                    .prop("checked", true)
                    .closest("li")
                    .addClass("selected");
                },
                this
              );
            },
            this
          );
        }

        // re-render jobs list
        this.renderJobGroups();
      },

      updateURL: function () {
        if (window.history && window.history.replaceState) {
          window.history.replaceState(
            this.activeFilters,
            document.title,
            url.addUrlParams(this.activeFilters)
          );
        }
      },

      renderJobGroups: function () {
        var jobGroupsFiltered = this.getFilteredJobsData();

        this.$jobGroupsContainer.html(
          !_.isEmpty(jobGroupsFiltered)
            ? this.templates.jobGroups({
              jobGroups: jobGroupsFiltered,
              hideGroupHeadings: !this.params.groupByTeam,
              jobGroupKeys: _.sortBy(
                _.keys(jobGroupsFiltered),
                function (key) {
                  return key === "None" ? Math.Infinity : key;
                }
              ),
              tableTemplate: this.templates.jobListTable,
            })
            : this.templates.emptyMessage()
        );

        // Sort the table by the first sortable column
        $(".sortColumn", this.$jobGroupsContainer).click();
      },

      bindJobTableEvents: function () {
        this.$jobGroupsContainer.on(
          "click",
          ".sortable .sortColumn",
          function () {
            var initialSort = ["ASC", "DESC"];
            var sorted = $(this).data("sorted"); // undefined, asc, desc
            var desiredSort =
              !sorted || sorted === "" || sorted == initialSort[1]
                ? initialSort[0]
                : initialSort[1];
            var sortBy = $(this).text();

            $(this)
              .removeClass("sorted-ASC")
              .removeClass("sorted-DESC")
              .data("sorted", desiredSort)
              .addClass("sorted-" + desiredSort);

            // assuming we're using a <table> for right now
            // figure out which td we're on
            var index = $(this).parent("tr").find("th").index($(this));
            var containerEl = $(this)
              .parentsUntil(".sortable")
              .parent(".sortable");

            // attach sort data to <tr>s
            containerEl.find("tr.data-row").each(function () {
              var thisTD = $(this).children("td").eq(index);
              var sortVal = thisTD.text();

              $(this).data("sort-by", sortBy).data("sort-val", sortVal);
            });

            var rows = containerEl.find(".data-row");

            rows.sort(function (a, b) {
              var av = $(a).data("sort-val");
              var bv = $(b).data("sort-val");
              var retVal = 0;

              if (av > bv) {
                retVal = 1;
              }
              if (av < bv) {
                retVal = -1;
              }

              if (desiredSort == initialSort[0]) {
                return retVal;
              } else {
                return -retVal;
              }
            });

            rows.detach().appendTo(containerEl);
          }
        );
      },

      getJobsGroupedByTeam: function () {
        var dupes = {};
        var groupedJobs = _.groupBy(
          this.allJobsData,
           (item) => {
            var r = "None"; // fallback group

            if (item && Array.isArray(item.team) && item.team.length) {
              var foundMatchingGroup = false,
                filterGroupKey;

              // loop through all predefined groups, and see if this job either matches exactly or is part of the array of accepted values
              for (filterGroupKey in this.teamFilterGroups) {
                for (var i = 0; i < item.team.length; ++i) {
                  if (
                    _.contains(
                      this.teamFilterGroups[filterGroupKey],
                      item.team[i]
                    )
                  ) {
                    // if this item has already found a matching group, add it to the dupes hash
                    if (!foundMatchingGroup) {
                      r = filterGroupKey;
                    } else {
                      dupes[filterGroupKey] = dupes[filterGroupKey] || [];
                      dupes[filterGroupKey].push(item);
                    }

                    foundMatchingGroup = true;
                  }
                }
              }
            }

            return r;
          },
          this
        );

        // merge in dupes and re-sort by city
        _.each(_.keys(dupes), function (key) {
          groupedJobs[key] = groupedJobs[key] || [];
          groupedJobs[key] = _.sortBy(
            groupedJobs[key].concat(dupes[key]),
            function (job) {
              return job.location;
            }
          );
        });

        return groupedJobs;
      },

      getFlattenedJobGroup: function () {
        var flatGroup = {};
        flatGroup[this.params.filterValue] = this.allJobsData;
        return flatGroup;
      },

      // reduce all grouped jobs down to those that match our activeFilters
      getFilteredJobsData: function () {
        var jobGroupsFiltered = _.clone(this.allJobsDataGrouped);

        _.each(
          _.keys(this.activeFilters),
          function (key) {
            switch (key) {
              case "team":
                if (
                  this.activeFilters[key] &&
                  this.activeFilters[key].length &&
                  this.activeFilters[key][0]
                ) {
                  jobGroupsFiltered = _.pick(
                    jobGroupsFiltered,
                    function (v, k) {
                      return _.contains(this.activeFilters[key], k);
                    },
                    this
                  );
                }
                break;
              case "location":
                if (this.activeFilters[key] && this.activeFilters[key].length) {
                  jobGroupsFiltered = _.mapObject(
                    jobGroupsFiltered,
                    function (v) {
                      return _.filter(
                        v,
                        function (job) {
                          return job.location
                            ? _.contains(this.activeFilters[key], job.location)
                            : false;
                        },
                        this
                      );
                    },
                    this
                  );
                }
                break;
            }
          },
          this
        );

        // only return those that have at least one job under them
        return _.pick(jobGroupsFiltered, function (value) {
          return value && value.length;
        });
      },

      precompileTemplates: function () {
        for (var prop in this.templates) {
          if (typeof this.templates[prop] === "string") {
            this.templates[prop] = _.template(this.templates[prop]);
          }
        }
      },

      templates: {
        /* jshint ignore:start */
        filters:
          '\
                        <div class="grid grid-2 filters">\
                        <% if (teamGroups && teamGroups.length > 1) { %>\
                            <div class="column colspan-1 filter-group teams">\
                                <h4 class="alt">Team</h4>\
                                <ul>\
                                <% _.each(teamGroups, function(group, i, arr) { %>\
                                    <% if (i === Math.ceil(arr.length/2)) { %>\
                                        </ul><ul>\
                                    <% } %>\
                                    <li>\
                                        <label>\
                                            <input class="filter-item" data-filter-type="team" type="checkbox" name="<%= group %>" value="<%= group %>" />\
                                            <span></span>\
                                            <%= group %>\
                                        </label>\
                                    </li>\
                                <% }); %>\
                                </ul>\
                            </div>\
                        <% } %>\
                        <% if (locationGroups && locationGroups.length > 1) { %>\
                            <div class="column colspan-1 filter-group location">\
                                <h4 class="alt">Location</h4>\
                                <ul>\
                                <% _.each(locationGroups, function(group, i, arr) { %>\
                                    <% if (i === Math.ceil(arr.length/2)) { %>\
                                        </ul><ul>\
                                    <% } %>\
                                    <li>\
                                        <label>\
                                            <input class="filter-item" data-filter-type="location" type="checkbox" name="<%= group %>" value="<%= group %>" />\
                                            <span></span>\
                                            <%= group %>\
                                        </label>\
                                    </li>\
                                <% }); %>\
                                </ul>\
                            </div>\
                        <% } %>\
                        </div>\
                    ',
        jobGroups:
          '\
                        <% _.each(jobGroupKeys, function(key) { %>\
                            <div class="job-group">\
                            <% if (!hideGroupHeadings) { %>\
                                <h3 style="text-transform: capitalize;"><%= key %></h3>\
                            <% } %>\
                                <%= tableTemplate({jobs: jobGroups[key]}) %>\
                            </div>\
                        <% }); %>\
                    ',
        jobListTable:
          '\
                        <table class="careers-job-list sortable">\
                            <tr>\
                                <th class="alt">Position</th>\
                                <th class="alt sortColumn">Location</th>\
                            </tr>\
                            <% _.each(jobs, function(job) { %>\
                                <tr class="data-row">\
                                    <td>\
                                        <a href="<%= job._hostedUrl %>" data-api-endpoint="<%= job.ref %>"><%= job.text %></a>\
                                    </td>\
                                    <td>\
                                        <%= job.location %>\
                                    </td>\
                                </tr>\
                            <% }); %>\
                        </table>\
                    ',
        emptyMessage:
          '\
                        <div class="empty-message">\
                            <h4>There are currently no openings in this category, check back soon or <a href="https://www.atlassian.com/company/contact/">contact us</a></h4>\
                        </div>\
                    ',
        /* jshint ignore:end */
      },
    };
    /*
     * END JOBS LIST
     */

    var processJobListPlaceholders = function () {
      $(".job-list-container").each(function () {
        var filterType = $(this).data("filter-type");
        var filter = $(this).data("filter");

        // any filtering operations are going to require underscore
        switch (filterType) {
          case "team":
            new imkt.careers.JobsList($(this), {
              filterType: filterType,
              filterValue: filter,
              groupByTeam: false,
              queryParams: {
                team: filter,
              },
            });
            break;
          case "location":
            new imkt.careers.JobsList($(this), {
              filterType: filterType,
              filterValue: filter,
              queryParams: {
                location: filter,
              },
            });
            break;
          case "all-jobs":
            new imkt.careers.JobsList($(this), {
              filterType: filterType,
              queryParams: {
                limit: 500,
              },
            });
            break;
        }
      });
    };

    // KICKOFF
    processJobListPlaceholders();
  } // end isEditMode check
});
